const DISMISS_DELAY = 4000;
const ANIMATION_MS = 300;

function dismiss(el: Element): void {
    el.classList.add("toast--leaving");
    setTimeout(() => el.remove(), ANIMATION_MS);
}

/**
 * Programmatically shows a Blade-style toast notification.
 * Mirrors the markup from partials/toast.blade.php.
 */
export function showBladeToast(
    message: string,
    type: "success" | "error" | "info" = "success",
): void {
    let container = document.querySelector<HTMLElement>(".toast-container");
    if (!container) {
        container = document.createElement("div");
        container.className = "toast-container";
        container.setAttribute("aria-live", "polite");
        document.body.appendChild(container);
    }

    const toast = document.createElement("div");
    toast.className = `toast toast--${type}`;
    toast.setAttribute("role", type === "error" ? "alert" : "status");

    const messageEl = document.createElement("span");
    messageEl.className = "toast__message";
    messageEl.textContent = message;

    const closeBtn = document.createElement("button");
    closeBtn.className = "toast__close";
    closeBtn.setAttribute("aria-label", "Fermer");
    closeBtn.type = "button";
    closeBtn.textContent = "×";

    const dismissToast = (): void => {
        toast.classList.add("toast--leaving");
        setTimeout(() => toast.remove(), ANIMATION_MS);
    };
    closeBtn.addEventListener("click", dismissToast);

    toast.append(messageEl, closeBtn);
    container.appendChild(toast);
    requestAnimationFrame(() => toast.classList.add("toast--visible"));
    setTimeout(dismissToast, DISMISS_DELAY);
}

function initSessionToasts(): void {
    document.querySelectorAll("[data-toast]").forEach((el) => {
        requestAnimationFrame(() => el.classList.add("toast--visible"));
        setTimeout(() => dismiss(el), DISMISS_DELAY);
    });
}

document.addEventListener("show-toast", ((event: CustomEvent) => {
    const detail = event.detail as
        | { message?: string; type?: "success" | "error" | "info" }
        | undefined;
    if (detail?.message) {
        showBladeToast(detail.message, detail.type ?? "success");
    }
}) as EventListener);

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSessionToasts);
} else {
    initSessionToasts();
}
